export default __webpack_public_path__ + "static/media/online-logo.3d1206cd.svg";